import { APIResponse, PaginatedAPIResponse } from "../models/NetworkResponse";
import { getAPI, postMultipartAPI } from "./Networking";
import { VoucherCSVRow } from "../models/Vouchers/VoucherEmailer";
import { VoucherDetail } from "../models/Vouchers/VoucherDetail";
import { VoucherEmailerFilters } from "../models/Vouchers/VoucherEmailerFilters";

export default class EmailerAPI {
  sendVoucherEmails = async (
    csvFile: File,
    logoFile: File | null,
    subject: string,
    message: string,
    template: string,
    hideSwageazyLogo: boolean,
  ): Promise<APIResponse> => {
    try {
      const formData = new FormData();
      formData.append("csv", csvFile);
      if (logoFile) {
        formData.append("logo", logoFile);
      }
      formData.append("subject", subject);
      formData.append("message", message);
      formData.append("template_id", template);
      formData.append("hide_swageazy_logo", hideSwageazyLogo.toString());

      const response = await postMultipartAPI(
        `/v5/emailers/send-vouchers`,
        formData,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  sendTestVoucherEmail = async (
    csvFile: File,
    logoFile: File | null,
    subject: string,
    message: string,
    template: string,
    hideSwageazyLogo: boolean,
    testEmails: string[],
    sampleVoucher: VoucherCSVRow,
  ): Promise<APIResponse> => {
    try {
      const formData = new FormData();
      formData.append("csv_file", csvFile);
      if (logoFile) {
        formData.append("logo_file", logoFile);
      }
      formData.append("subject", subject);
      formData.append("message", message);
      formData.append("template", template);
      formData.append("hide_swageazy_logo", hideSwageazyLogo.toString());
      formData.append("test_emails", JSON.stringify(testEmails));
      formData.append("sample_voucher", JSON.stringify(sampleVoucher));

      const response = await postMultipartAPI(
        `/v5/emailers/send-test-voucher`,
        formData,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getVoucherEmailers = async (
    filters: VoucherEmailerFilters,
  ): Promise<PaginatedAPIResponse<VoucherDetail>> => {
    try {
      const params = new URLSearchParams({
        page_no: filters.page_no.toString(),
        limit: filters.limit.toString(),
        sort_by: filters.sort_by,
        sort_type: filters.sort_type,
      });

      if (filters.search_text) {
        params.append("search_text", filters.search_text);
      }

      const response = await getAPI(
        `/v5/emailers/vouchers?${params.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
